<template>
  <div>
    <div class="box bg-white" v-if="!loading_i">
      <!-- TAB -->
      <ul class="nav nav-tabs red" id="tabs-tab" role="tablist">
        <li class="nav-item" role="presentation" v-if="total_awlr >= 1">
          <button class="nav-link d-flex flex-row py-0 px-2" :class="{ active: total_awlr >= 1 }" id="tabs-AWLR-tab"
            data-bs-toggle="pill" data-bs-target="#tabs-AWLR" type="button" role="tab" aria-controls="tabs-AWLR"
            aria-selected="true">
            <img :src="awlr_i" class="rounded mx-auto d-inline imgSZ" />

            <span>AWLR</span>
          </button>
        </li>
        <li class="nav-item" role="presentation" v-if="total_arr >= 1">
          <button class="nav-link d-flex flex-row py-0 px-2" :class="{ active: total_arr >= 1 && total_awlr < 1 }"
            id="tabs-ARR-tab" data-bs-toggle="pill" data-bs-target="#tabs-ARR" type="button" role="tab"
            aria-controls="tabs-ARR" aria-selected="false">
            <img :src="arr_i" class="rounded mx-auto d-inline imgSZ" />
            <span>ARR</span>
          </button>
        </li>
        <li class="nav-item" role="presentation" v-if="total_aws >= 1">
          <button class="nav-link d-flex flex-row py-0 px-2" :class="{
            active: total_aws >= 1 && total_arr < 1 && total_awlr < 1,
          }" id="tabs-AWS-tab" data-bs-toggle="pill" data-bs-target="#tabs-AWS" type="button" role="tab"
            aria-controls="tabs-AWS" aria-selected="false">
            <img :src="aws_i" class="rounded mx-auto d-inline imgSZ" />
            <span>AWS</span>
          </button>
        </li>
      </ul>

      <div class="tab-content station-list" id="tabs-tabContent">
        <!-- AWLR -->

        <div v-if="total_awlr >= 1" class="tableFixHead tab-pane fade" :class="{
          active: total_awlr >= 1,
          show: total_awlr >= 1,
          h100: ava_width <= 850,
        }" id="tabs-AWLR" role="tabpanel" aria-labelledby="tabs-AWLR-tab">
          <table class="table table-hover table-responsive text-nowrap text-center table-border">
            <thead>
              <tr>
                <th v-for="(head, index) in awlr_head" :key="index"
                  :class="{ thClass: index >= 0, sticky: index === 2 }">
                  {{ head }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(station, index) in awlr_stations" :key="station[0].id">
                <td>{{ index + 1 }} </td>
                <td>
                  <span v-if="station[1].table.siaga == []"> </span>
                  <span v-else-if="station[1].table.siaga == 'MAINTENANCE'">
                    <img :src="mtc_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 1'">
                    <img :src="s1_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 2'">
                    <img :src="s2_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 3'">
                    <img :src="s3_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'OK'">
                    <img :src="ok_i" class="statSZ" />
                  </span>
                </td>
                <td>
                  {{ station[0].station_name }}
                </td>
               <td>
                  <router-link type="button" class="btn btn-sm btn-primary m-0 p-0"
                    style="font-size: 0.8rem; padding: 0 5px!important;"
                    :to="{ path: `/station/data/${station[0].id}/1`}">Data</router-link>
                </td>
                <td>
                  {{ formatDate(station[1].table.date) }}
                </td>
                <td>
                  {{ formatTime(station[1].table.date) }}
                </td>
                <td v-for="(sensor, index) in conf_2(
                  station[1].table.weather_data,
                  station[1].table.array_act_symbol
                )" :key="index">
                  {{ sensor.data }} {{ sensor.symbol }}
                </td>


              </tr>
            </tbody>
          </table>
        </div>
        <!-- ARR -->
        <div v-if="total_arr >= 1" class="tableFixHead tab-pane fade" :class="{
          active: total_arr >= 1 && total_awlr < 1,
          show: total_arr >= 1 && total_awlr < 1,
          h100: ava_width <= 850,
        }" id="tabs-ARR" role="tabpanel" aria-labelledby="tabs-ARR-tab">

          <table class="table table-hover table-responsive text-nowrap text-center table-border bg-white mx-2">
            <thead class="table-light">
              <tr>
                <th v-for="(head, index) in arr_head" :key="index"
                  :class="{ thClass: index >= 0, sticky: index === 2 }">
                  {{ head }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(station, index) in arr_stations" :key="station[0].id">
                <td>{{ index + 1 }}</td>
                <td>
                  <span v-if="station[1].table.siaga == []"> </span>
                  <span v-else-if="station[1].table.siaga == 'MAINTENANCE'">
                    <img :src="mtc_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 1'">
                    <img :src="s1_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 2'">
                    <img :src="s2_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 3'">
                    <img :src="s3_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'OK'">
                    <img :src="ok_i" class="statSZ" />
                  </span>
                </td>
                <td>
                  {{ station[0].station_name }}
                </td>
                
                <td>
                  {{ formatDate(station[1].table.date) }}
                </td>
                <td>
                  {{ formatTime(station[1].table.date) }}
                </td>
                <td v-for="(sensor, index) in conf_2(
                  station[1].table.weather_data,
                  station[1].table.array_act_symbol
                )" :key="index">
                  {{ sensor.data }} {{ sensor.symbol }}
                </td>


              </tr>
            </tbody>
          </table>
        </div>
        <!-- AWS -->
        <div v-if="total_aws >= 1" class="tableFixHead tab-pane fade" :class="{
          active: total_aws >= 1 && total_arr < 1 && total_awlr < 1,
          show: total_aws >= 1 && total_arr < 1 && total_awlr < 1,
          h100: ava_width <= 850,
        }" id="tabs-AWS" role="tabpanel" aria-labelledby="tabs-AWS-tab">
          <table class="table table-hover table-responsive text-nowrap text-center table-border bg-white mx-2">
            <thead class="table-light">
              <tr>
                <th v-for="(head, index) in aws_head" :key="index"
                  :class="{ thClass: index >= 0, sticky: index === 2 }">
                  {{ head }}
                </th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="(station, index) in aws_stations" :key="station[0].id">
                <td>{{ index + 1 }}</td>
                <td>
                  <span v-if="station[1].table.siaga == []"> </span>
                  <span v-else-if="station[1].table.siaga == 'MAINTENANCE'">
                    <img :src="mtc_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 1'">
                    <img :src="s1_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 2'">
                    <img :src="s2_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'SIAGA 3'">
                    <img :src="s3_i" class="statSZ" />
                  </span>
                  <span v-else-if="station[1].table.siaga == 'OK'">
                    <img :src="ok_i" class="statSZ" />
                  </span>
                </td>

                <td>
                  {{ station[0].station_name }}
                </td>

                <td>
                  {{ formatDate(station[1].table.date) }}
                </td>
                <td>
                  {{ formatTime(station[1].table.date) }}
                </td>
                <td v-for="(sensor, index) in conf_2(
                  station[1].table.weather_data,
                  station[1].table.array_act_symbol
                )" :key="index">
                  {{ sensor.data }} {{ sensor.symbol }}
                </td>


              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import axios from "axios";
import awlr_i from "@/assets/icons/map/awlr.svg";
import arr_i from "@/assets/icons/map/arr.svg";
import aws_i from "@/assets/icons/map/aws.svg";
import mtc_i from "@/assets/icons/map/mtc.svg";
import ok_i from "@/assets/icons/map/ok.svg";
import s1_i from "@/assets/icons/map/s1.svg";
import s2_i from "@/assets/icons/map/s2.svg";
import s3_i from "@/assets/icons/map/s3.svg";

export default {
  name: "Stations",
  data() {
    return {
      stations: [],
      backupStat: [],
      awlr_stations: [],
      arr_stations: [],
      aws_stations: [],
      awlr_head: [],
      arr_head: [],
      aws_head: [],

      total_awlr: null,
      total_arr: null,
      total_aws: null,

      awlr_head_pre: [],
      arr_head_pre: [],
      aws_head_pre: [],
      role: null,
      balai: null,
      indexSt: null,
      loading_i: true,
      ava_width: null,
      ava_height: null,
      awlr_i,
      arr_i,
      aws_i,
      mtc_i,
      ok_i,
      s1_i,
      s2_i,
      s3_i,
      intervalId: null
    };
  },

  methods: {
    conf_2(a, b) {
      return a.map((card, i) => {
        return {
          data: card,
          symbol: b[i],
        };
      });
    },
    formatDate(date) {
      var monthShortNames = [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "Mei",
        "Jun",
        "Jul",
        "Agu",
        "Sep",
        "Okt",
        "Nov",
        "Des",
      ];
      var d = new Date(date),
        year = d.getFullYear(),
        month = "" + d.getMonth(),
        day = "" + d.getDate();

      if (day.length < 2) day = "0" + day;
      return [day, monthShortNames[month], year].join(" ");
    },
    formatTime(date) {
      var d = new Date(date),
        hour = "" + d.getHours(),
        minute = "" + d.getMinutes(),
        second = d.getSeconds();

      if (hour.length < 2) hour = "0" + hour;
      if (minute.length < 2) minute = "0" + minute;
      if (second.length < 2) second = "0" + second;

      return [hour, minute].join(":");
    },

    async loadStations() {
      try {
        const response = await axios.get(`${this.$baseURL}/home-data/non-auth/${this.balai}`);
        const { data, status } = response;

        if (status === 200) {
          this.stations = data;
          this.loading_i = false;
          this.processStations(); // Extracted logic for processing stations
          this.updateHeaders();   // Extracted logic for updating headers
        }
      } catch (e) {
        console.log(e);
      }

      // Auto refresh data and update headers every 15 seconds
      if (this.$options.name === 'Stations') {
        this.intervalId = setInterval(() => {
          this.refreshStationData();
        }, 15000);
      }
      // console.log(this.$options.name);
      // console.log(this.intervalId);
    },

    processStations() {
      this.awlr_stations = [];
      this.arr_stations = [];
      this.aws_stations = [];

      this.stations.forEach(station => {
        const type = station[0].station_type;
        switch (type) {
          case 2:
            this.awlr_stations.push(station);
            break;
          case 1:
            this.arr_stations.push(station);
            break;
          case 3:
            this.aws_stations.push(station);
            break;
        }
      });

      this.total_awlr = this.awlr_stations.length;
      this.total_arr = this.arr_stations.length;
      this.total_aws = this.aws_stations.length;
    },

    updateHeaders() {
      this.awlr_head = ["No", "Status", "Nama Stasiun", "Data", "Tanggal", "Waktu"];
      this.arr_head = ["No", "Status", "Nama Stasiun", "Tanggal", "Waktu"];
      this.aws_head = ["No", "Status", "Nama Stasiun", "Tanggal", "Waktu"];

      const addUniqueLabels = (stations, header, headPre, index) => {
        stations.forEach(station => headPre.push(station[1].table.array_table_label));
        const uniqueLabels = Array.from(new Set(headPre[0]));
        header.splice(index, 0, ...uniqueLabels);
      };

      addUniqueLabels(this.awlr_stations, this.awlr_head, this.awlr_head_pre, 6);
      addUniqueLabels(this.arr_stations, this.arr_head, this.arr_head_pre, 5);
      addUniqueLabels(this.aws_stations, this.aws_head, this.aws_head_pre, 5);
    },

    async refreshStationData() {
      try {
        const response = await axios.get(`${this.$baseURL}/home-data/non-auth/${this.balai}`);
        this.stations = response.data;
        this.processStations();
        this.updateHeaders();
      } catch (e) {
        console.log(e);
      }
    },


    getYear(x) {
      var d = new Date(x),
        year = d.getFullYear();
      return year;
    },
    handleScroll() {
      const stickyCol = document.querySelector("th.sticky");
      const table = document.querySelector("table");
      const tableRect = table.getBoundingClientRect();
      const stickyColRect = stickyCol.getBoundingClientRect();

      if (
        stickyColRect.top <= tableRect.top &&
        stickyColRect.bottom >= tableRect.bottom
      ) {
        stickyCol.style.top = "0";
      } else if (stickyColRect.top <= tableRect.top) {
        stickyCol.style.top = `${tableRect.top - stickyColRect.top}px`;
      } else if (stickyColRect.bottom >= tableRect.bottom) {
        stickyCol.style.top = `${tableRect.bottom - stickyColRect.bottom}px`;
      }
    },
  },

  created() {
    this.ava_width = screen.availWidth;
    this.ava_height = screen.availHeight;


    this.userJSONParse();

  },
  mounted() {
    this.loadStations();
    window.addEventListener("scroll", this.handleScroll);
  },
  destroyed() {
    window.removeEventListener("scroll", this.handleScroll);
  },
  beforeDestroy() {
    if (this.intervalId) {
      clearInterval(this.intervalId);
    }
  }
};
</script>

<style scoped>
.tableFixHead {
  overflow-y: scroll;
  height: 39vh;
}

.tableFixPDAM {
  overflow-y: scroll;
  height: 28vh;
}

.tableFixHead table {
  border-collapse: collapse;
  width: 100%;
}

.tableFixHead th,
.tableFixHead td {
  padding: 2px 7px !important;
}

.tableFixHead th {
  position: sticky !important;
  top: 0;
  background: #f8fafc;
}

.tableFixHead td {
  background: #fff;
}

.h100 {
  min-height: 70vh;
}

.thClass {
  font-weight: normal;
  color: #696969;
  font-size: 0.9rem;
}

td {
  font-size: 0.9rem;
}

.table-border td,
.table-border th {
  border: none !important;
  border-right: solid 1px #ccc !important;
}

.table> :not(:first-child) {
  border-top: 0;
}

.imgSZ {
  height: 25px;
}

thead {
  padding: 20px !important;
}

th:nth-child(3),
td:nth-child(3) {
  position: sticky;
  left: 0px;
  z-index: 5;
}

th.sticky {
  position: sticky;
  left: 0;
  top: 0;
  z-index: 10;
  background-color: #fff;
}

.nav-link.active {
  background: #3056d3 !important;
  color: #fff !important;
}

.nav-link {
  color: #555555 !important;
}

.statSZ {
  height: 1.5rem;
}
</style>